import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Users } from '../../models/users';
import { AdminApiService } from '../../services/admin.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-clear-page',
  templateUrl: './clear-page.component.html',
  styleUrls: ['./clear-page.component.css']
})
export class ClearPageComponent implements OnInit {

  constructor(private _router: Router,
    private _activatedRoute: ActivatedRoute, public restApi: AdminApiService) { }

  ngOnInit(): void {
    if (environment.PingEnabled == true) {

      this.restApi.PingLogout().subscribe({
      next: (data: any) => {

        if (data.description == "Success") {
          window.location.href = data.data;
        }
      },
      error: (error) => {
        console.log("PING LOGOUT ERROR: ", error);
      },
      complete: () => {
      }
    });
    }
    else {
      this._router.navigateByUrl('/');
    }
  }
  
}
